<template>
  <div v-if="minicartGiftChoiceModal"
       :id="this.identity"
       class="modal show reactive-gift-choice--modal"
       tabindex="-1"
       role="dialog"
       aria-labelledby="ReactiveGiftChoiceModalLabel"
       aria-hidden="true">
    <div class="modal-dialog reactive-gift-choice--modal-dialog" role="document">
      <div class="modal-content reactive-gift-choice--content">
        <div class="modal-header reactive-gift-choice--content-header">
          <div class="modal-header-wrapper">
            <h5 class="modal-title col-12" id="ReactiveGiftChoiceModalLabel">{{ t('modal.subtitle', { namespace: 'giftSelection' }) }}</h5>
            <span class="modal-title-sub col-12">{{t('modal.minicart.info.text', { namespace: 'giftSelection' }) }}</span>
          </div>
        </div>
        <div class="modal-body reactive-gift-choice--content-body">
          <adv-cart-gift-list :enable-picker="true"
                              :styling-options="stylingOptions"
                              :gift-choices-filter="filterGiftsWithChoice"></adv-cart-gift-list>
        </div>
        <div class="modal-footer reactive-gift-choice--content-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="unselectGifts">{{
              t('modal.action.clear', { namespace: 'giftSelection' }) }}</button>
          <button type="button" class="btn btn-primary" @click="hideModal">{{
              t('modal.action.submit', { namespace: 'giftSelection' }) }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdvCartGiftList from './AdvCartGiftList'
import giftChoiceMixin from './mixins/giftChoiceMixin'
import { mapState } from 'vuex'
import store from '../../vue/store'
export default {
  name: 'AdvMinicartGiftChoiceModal',
  components: {
    AdvCartGiftList
  },
  mixins: [giftChoiceMixin],
  computed: {
    ...mapState(['minicartGiftChoiceModal'])
  },
  props: {
    identity: {
      type: String,
      required: false,
      default: 'GiftChoiceModal'
    }
  },
  data () {
    return {
      stylingOptions: {
        items: 'col-6 col-sm-4 col-md-12'
      }
    }
  },
  methods: {
    hideModal: function () {
      store.dispatch('popupMinicartGiftModal', false)
    },
    unselectGifts: function () {
      localStorage.setItem('giftSelection', JSON.stringify([]))
      store.commit('unselectGifts')
      this.hideModal()
    }
  }
}
</script>
